module.exports = __webpack_public_path__ + "img/horizontal_4_1_r_8003.289d0bef.png";